angular.module('wbDashboard')
.controller('PlanningSurveyControllerAurea', ['$scope', '$window', '$q', 'PlanningService', 'ThinkingService', 'surveyResolve', 'answersResolve', 'Track', 'Message',
function ($scope, $window, $q, PlanningService, ThinkingService, surveyResolve, answersResolve, Track, Message) {
    $scope.pageData.last = false;
    $scope.pageData.percent = 0;

    $scope.survey = surveyResolve;
    $scope.question = null;
    $scope.answers = {};
    $scope.skipped = [];
    $scope.surveyCompleted = angular.copy(answersResolve);
    if ($scope.surveyCompleted) {
        $scope.answers = $scope.surveyCompleted.answers;
    }

    $scope.receipt = {};
    //store the current data so it can be compared after new data is retrieved
    $scope.r = {
        prevInfo: PlanningService.getRecommendationInfo(),
        prevRecommendations: PlanningService.getRecommendations()
    };

    $scope.saveSurvey = function () {
        var thinkingInstance, answers = [];

        $scope.pageData.sending = true;
        $scope.pageData.thinking = true;
        thinkingInstance = ThinkingService.open($scope, 'survey');

        answers = PlanningService.formatSavedAnswers($scope.survey.questions, $scope.answers, $scope.skipped);
        PlanningService.saveSurvey($scope.survey.id, answers).catch(function(err) {
            Message.set({
                key: 'survey',
                type: 'warning',
                text: 'Error saving the survey'
            });
            throw err;
        }).then(function(response) {
            Track.send("Survey Completed", "planning", {
                survey: $scope.survey.recommendation_description.title,
                flow: $scope.survey.completed ? "Edit" : "New"
            });
            return response;
        }).then(function() {
            var retrieve;

            retrieve = [
                PlanningService.retrieveSurvey($scope.survey.id, true),
                PlanningService.retrieveRecommendations(true),
                PlanningService.retrieveSurveysCompleted(null, true)
            ];
            if (   PlanningService.riskInfo.surveyId === $scope.survey.id
                || PlanningService.partnerListSurveyId.includes($scope.survey.id)) {
                //haven, student refi
                //don't need to wait for them since there will be a loading page next
            } else {
                return $q.all(retrieve);
            }
        }).then(function() {
            $scope.pageData.thinking = false;
            if (PlanningService.partnerListSurveyId.includes($scope.survey.id)) {
                ThinkingService.close(true, 'survey');
                switch ($scope.survey.id) {
                    case PlanningService.partnerInfo.haven.surveyId:
                        $scope.$state.go("base.planning.haven", {recommendationSlug: $scope.$stateParams.recommendationSlug});
                        break;
                    case PlanningService.partnerInfo.studentRefi.surveyId:
                        $scope.$state.go("base.planning.studentrefi", {recommendationSlug: $scope.$stateParams.recommendationSlug});
                        break;
                    case PlanningService.partnerInfo.mortgage.surveyId:
                        $scope.$state.go("base.planning.mortgage", {recommendationSlug: $scope.$stateParams.recommendationSlug});
                        break;
                    case PlanningService.partnerInfo.mortgageNew.surveyId:
                        $scope.$state.go("base.planning.mortgage-new", {recommendationSlug: $scope.$stateParams.recommendationSlug});
                        break;
                }

            } else if (PlanningService.riskInfo.surveyId === $scope.survey.id) {
                ThinkingService.close(false, 'survey');
                $scope.$state.go("base.planning.risk-score", {recommendationSlug: $scope.$stateParams.recommendationSlug});
            } else {
                ThinkingService.close(false, 'survey');
                if ($scope.survey.completed) {
                    Message.set({
                        key: 'survey',
                        type: 'success',
                        text: 'Success! Go back to the Planning Progress page to see if you have any updated recommendations.',
                        timeout: 10
                    });
                    $scope.$state.go('base.profile.planning');
                } else {
                    $scope.$state.go("base.planning.survey.complete");
                }
            }
        }).catch(function() {
            ThinkingService.close(true, 'survey');
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    /**
     * This will retrieve the next question and go to the next page, or submit if there is no next question
     */
    $scope.goNextPage = function(replace) {
        var options = {};
        var nextQuestion = $scope.getNextQuestion();

        if (!nextQuestion && !$scope.survey.questions.length) {
            Message.set({
                key: 'survey',
                type: 'warning',
                text: 'No questions available for this survey'
            });
            $scope.$state.go("base.planning");
            return;
        }

        if ($scope.question && !$scope.skipped.includes($scope.question.id)) {
            Track.send("Question Answered", "planning", {
                question: $scope.question.question,
                survey: $scope.survey.recommendation_description.title,
                flow: $scope.survey.completed ? "Edit" : "New"
            });
        }

        if (!nextQuestion) {
            //no more questions, submit
            $scope.saveSurvey();
        } else if (nextQuestion) {
            if (replace) {
                options.location = "replace";
            }
            $scope.$state.go("base.planning.survey.question", {code: nextQuestion.code}, options);
        }

    };

    /**
     * This determines what the next question is
     * It will start at the current question if none is specified and continue through till the next valid question is found
     * If it skips a question, it will delete answers to those questions if they exist
     *
     * @param curQuestion
     * @returns Question {} | null
     */
    $scope.getNextQuestion = function(curQuestion) {
        var curQIndex, nextQIndex = null, question, valid;

        /*jshint -W030 */
        curQuestion || (curQuestion = $scope.question);
        /*jshint +W030 */

        curQIndex = $scope.survey.questions.indexOf(curQuestion);

        while (nextQIndex === null) {
            curQIndex++;
            question = $scope.survey.questions[curQIndex];
            if (!question) {
                break;
            }

            valid = $scope.validQuestion(question);
            if (valid) {
                nextQIndex = curQIndex;
            } else {
                //skipping question
                delete $scope.answers[question.id];
                delete $scope.answers[question.id + "other"];
            }
        }

        return $scope.survey.questions[nextQIndex];

    };

    $scope.validQuestion = function(question) {
        var valid = true;
        question.show_conditions.forEach(function(condition) {
            var q, qId, qCode = condition.question_code;
            if (qCode) {
                q = PlanningService.getQuestion($scope.survey.questions, qCode);
                if (!q) {
                    alert("Invalid condition question code:" + JSON.stringify(condition));
                    return;
                }
                qId = q.id;
                if (!PlanningService.checkRule($scope.answers[qId], condition.answer, condition.operator)) {
                    valid = false;
                }
            }

        });
        return valid;
    };

    $scope.multipleNoneCheck = function (answer, value, qId, code) {
        if (value && code === "None") {
            //removed others checked
            angular.copy({"None": true}, answer);
        } else if (value && code !== "None") {
            //if anything else is checked, none can't be
            /*jshint -W069 */
            answer["None"] = false;
            /*jshint +W069 */
        }
    };

    /**
     * Field validation for multiple question
     */
    $scope.validateMultiCheckbox = function(answer) {
        var valid = false;
        angular.forEach(answer, function(value, code) {
            if (value) {
                valid = true;
            }
        });
        return valid;
    };

    $scope.skipQuestion = function() {
        delete $scope.answers[$scope.question.id];
        delete $scope.answers[$scope.question.id + "other"];
        $scope.skipped.push($scope.question.id);

        Track.send("Question Skipped", "planning", {
            question: $scope.question.question,
            survey: $scope.survey.recommendation_description.title,
            flow: $scope.survey.completed ? "Edit" : "New"
        });

        $scope.goNextPage();
    };
    $scope.unskipQuestion = function() {
        //make sure it's cleared when the page is loaded
        //user could skip and hit back, wouldn't want it still in the skipped list
        var index = $scope.skipped.indexOf($scope.question.id);
        if (index > -1) {
            $scope.skipped.splice(index, 1);
        }
    };

    /**
     * Will look for {questionCode} in a string and replace it with that questions value
     * @param string
     */
    $scope.parseParams = function(string) {
        var parsed = string;

        var qCodes = string.match(/{[^}]*}/g);
        angular.forEach(qCodes, function(qCode, index) {
            //because the global regex search above won't return groups
            qCode = qCode.match(/{(.*)}/)[1];
            var question = PlanningService.getQuestion($scope.survey.questions, qCode);
            if (question) {
                parsed = parsed.replace("{"+qCode+"}", $scope.answers[question.id]);
            } else {
                //remove the param without anything
                parsed = parsed.replace("{"+qCode+"}", "");
            }
        });

        return parsed;
    };


    var transitionDeregisterHook = {};
    transitionDeregisterHook[0] = $scope.$transitions.onBefore({ to: 'base.planning.survey.complete' }, function(trans) {
        initComplete();
        $scope.pageData.percent = 100;
    });
    transitionDeregisterHook[1] = $scope.$transitions.onBefore({ from: 'base.planning.survey.complete' }, function(trans) {
        PlanningService.setStageCompletedDone();
    });
    transitionDeregisterHook[2] = $scope.$transitions.onBefore({ to: 'base.planning.survey.question.**' }, function(trans) {
        //always load question from qCode in params
        //a fresh page load or coming into the survey from any other state will skip this and start the survey over
        var qCode = trans.params('to').code;
        if (qCode === "complete") {
            //user used forward in browser after getting to the receipt page and hitting back, must submit properly
            $window.history.back();
            return;
        }

        $scope.question = PlanningService.getQuestion($scope.survey.questions, qCode);
        if (!$scope.validQuestion($scope.question)) {
            //in case someone uses navigation weirdly
            $window.history.back();
            return;
            //TODO: just check the getNextQuestion against the new qCode just to make sure it's right
        } else {
            //will check to see if there are any questions beyond the next one selected, if not, this is the last one
            $scope.pageData.last = !$scope.getNextQuestion($scope.question);
        }

        if ($scope.forms.survey) {
            $scope.forms.survey.$setPristine(true);
            $scope.forms.survey.$setUntouched(true);
        }

        var index = $scope.survey.questions.indexOf($scope.question);
        $scope.pageData.percent = (index / $scope.survey.questions.length) * 100;
        if ($scope.pageData.last && $scope.pageData.percent < 95) {
            $scope.pageData.percent = 95;
        }

        Track.send("Question Viewed", "planning", {
            question: $scope.question.question,
            survey: $scope.survey.recommendation_description.title,
            flow: $scope.survey.completed ? "Edit" : "New"
        });

    });
    $scope.$on('$destroy', function() {
        angular.forEach(transitionDeregisterHook, function(hook) {
            if (typeof hook === "function") {
                hook();
            }
        });
    });

    //initializes page from beginning if question isn't set
    if (!$scope.question && $scope.$state.current.name !== "base.planning.survey.complete") {
        // startOver(!!$scope.$stateParams.code);
        startOver(false);
    } else if ($scope.$state.current.name === "base.planning.survey.complete") {
        initComplete();
    }

    function initComplete() {
        $scope.receipt = PlanningService.getReceiptInfo($scope.r.prevInfo, $scope.r.prevRecommendations);
    }


    function startOver(replace) {
        $scope.question = null;
        $scope.goNextPage(replace);
    }

}]);
